const generateServiceData = (t) => [
  {
    img: "/assets/img/brand_campaign_icon.svg",
    title: t('common:services.contentStrategy.title'),
    content: t('common:services.contentStrategy.description'),
  },
  {
    img: "/assets/img/analytics_icon.svg",
    title: t('common:services.performanceAnalytics.title'),
    content: t('common:services.performanceAnalytics.description'),
  },
  {
    img: "/assets/img/communication_icon.svg",
    title: t('common:services.brandCommunication.title'),
    content: t('common:services.brandCommunication.description'),
  },
  {
    img: "/assets/img/mailing_automation.svg",
    title: t('common:services.aiAutomation.title'),
    content: t('common:services.aiAutomation.description'),
  },
  {
    img: "/assets/img/lead_icon.svg",
    title: t('common:services.leadGeneration.title'),
    content: t('common:services.leadGeneration.description'),
  },
  {
    img: "/assets/img/retail_icon.svg",
    title: t('common:services.retailCreative.title'),
    content: t('common:services.retailCreative.description'),
  },
];

export { generateServiceData };
